import { render, staticRenderFns } from "./KorisnickeTransakcije.vue?vue&type=template&id=4715e7fc&scoped=true&"
import script from "./KorisnickeTransakcije.vue?vue&type=script&lang=ts&"
export * from "./KorisnickeTransakcije.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715e7fc",
  null
  
)

export default component.exports